module.exports = __webpack_public_path__ + "img/VR32.92108538.svg";